/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './patient-symptom-attribute.reducer';

export const PatientSymptomAttributeDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const patientSymptomAttributeEntity = useAppSelector(state => state.patientSymptomAttribute.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="patientSymptomAttributeDetailsHeading">
          <Translate contentKey="tinyMedicRestApp.patientSymptomAttribute.detail.title">PatientSymptomAttribute</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="tinyMedicRestApp.patientSymptomAttribute.id">Id</Translate>
            </span>
          </dt>
          <dd>{patientSymptomAttributeEntity.id}</dd>
          <dt>
            <span id="resultValue">
              <Translate contentKey="tinyMedicRestApp.patientSymptomAttribute.resultValue">Result Value</Translate>
            </span>
          </dt>
          <dd>{patientSymptomAttributeEntity.resultValue}</dd>
          <dt>
            <span id="active">
              <Translate contentKey="tinyMedicRestApp.patientSymptomAttribute.active">Active</Translate>
            </span>
          </dt>
          <dd>{patientSymptomAttributeEntity.active ? 'true' : 'false'}</dd>
          <dt>
            <span id="cursor">
              <Translate contentKey="tinyMedicRestApp.patientSymptomAttribute.cursor">Cursor</Translate>
            </span>
          </dt>
          <dd>{patientSymptomAttributeEntity.cursor}</dd>
          <dt>
            <span id="lastUpdated">
              <Translate contentKey="tinyMedicRestApp.patientSymptomAttribute.lastUpdated">Last Updated</Translate>
            </span>
          </dt>
          <dd>{patientSymptomAttributeEntity.lastUpdated}</dd>
          <dt>
            <span id="microSec">
              <Translate contentKey="tinyMedicRestApp.patientSymptomAttribute.microSec">Micro Sec</Translate>
            </span>
          </dt>
          <dd>{patientSymptomAttributeEntity.microSec}</dd>
          <dt>
            <span id="timestampEntry">
              <Translate contentKey="tinyMedicRestApp.patientSymptomAttribute.timestampEntry">Timestamp Entry</Translate>
            </span>
          </dt>
          <dd>{patientSymptomAttributeEntity.timestampEntry}</dd>
          <dt>
            <span id="symptomOrder">
              <Translate contentKey="tinyMedicRestApp.patientSymptomAttribute.symptomOrder">Symptom Order</Translate>
            </span>
          </dt>
          <dd>{patientSymptomAttributeEntity.symptomOrder}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.patientSymptomAttribute.symptomHistory">Symptom History</Translate>
          </dt>
          <dd>{patientSymptomAttributeEntity.symptomHistory ? patientSymptomAttributeEntity.symptomHistory.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.patientSymptomAttribute.attribute">Attribute</Translate>
          </dt>
          <dd>{patientSymptomAttributeEntity.attribute ? patientSymptomAttributeEntity.attribute.id : ''}</dd>
        </dl>
        <Button tag={Link} to="/patient-symptom-attribute" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/patient-symptom-attribute/${patientSymptomAttributeEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default PatientSymptomAttributeDetail;
